import React from 'react';
import clsx from 'clsx';

export function Card({ className, children, ...props }) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-zinc-200 bg-white shadow-card dark:border-zinc-800 dark:bg-zinc-900',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, description, actions, className }) {
  return (
    <div className={clsx('flex items-start justify-between gap-4 border-b border-zinc-100 px-5 py-4 dark:border-zinc-800', className)}>
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">{title}</h3>
        {description && <p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-400">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export function CardBody({ className, children }) {
  return <div className={clsx('px-5 py-4', className)}>{children}</div>;
}

/** Метрика: подпись, значение, необязательные изменение и подсказка */
export function StatCard({ label, value, hint, delta, icon: Icon, tone = 'neutral' }) {
  const deltaTone = delta === undefined || delta === null ? null : delta >= 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400';
  const iconTone = {
    neutral: 'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300',
    brand: 'bg-brand-50 text-brand-600 dark:bg-brand-950/60 dark:text-brand-300',
    success: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950/50 dark:text-emerald-400',
    warning: 'bg-amber-50 text-amber-600 dark:bg-amber-950/50 dark:text-amber-400',
    danger: 'bg-red-50 text-red-600 dark:bg-red-950/50 dark:text-red-400',
  }[tone];
  return (
    <Card className="p-5">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-medium text-zinc-500 dark:text-zinc-400">{label}</p>
        {Icon && (
          <span className={clsx('flex h-8 w-8 items-center justify-center rounded-lg', iconTone)}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <p className="tabular mt-2 text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">{value}</p>
      {(hint || deltaTone) && (
        <p className="mt-1 text-xs text-zinc-500 dark:text-zinc-400">
          {deltaTone && <span className={clsx('tabular mr-1 font-medium', deltaTone)}>{delta >= 0 ? '+' : ''}{delta}%</span>}
          {hint}
        </p>
      )}
    </Card>
  );
}
